import React from 'react'

const Header = ({ title }) => {
  return (
    <>
      <h1>{title}</h1>
      <p></p>
    </>
  )
}

export default Header
